export default {"src":"https://web.cdn.greenlight.com/2.1080.0/_next/static/media/icon-area.a8e2577c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};